import { toKm } from "@leafly-com/web-utils";

export const localizedDistance = (
  miles: number | undefined,
  countryCode: string,
  abbrev = false
) => {
  if (!miles && miles !== 0) {
    return null;
  }

  const isCanadian = countryCode === "CA";
  const localDistance = isCanadian ? (toKm(miles) as number) : miles;
  const fixedDistance = localDistance.toFixed(1);

  return `${fixedDistance} ${isCanadian ? "km" : `${abbrev ? "mi" : "miles"}`}`;
};
